import "./bootstrap";
import "sweetalert2";
import "toastr";

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

$("#withCustomEvent").on("hide.bs.dropdown", function (e) {
    console.log("hellllo!");
    if (e.clickEvent) {
        e.preventDefault();
    }
});
